import get from 'lodash/get';

import { AppRootState } from '../../../../store/models/app-state.model';
import { CAMPAIGNS_FEATURE } from '../../../../store/utils/files-names';

export const getAreCampaignsFiltersVisible = (state: AppRootState): boolean =>
  get(state, CAMPAIGNS_FEATURE).campaigns.areCampaignsFiltersVisible;
